import React from 'react'
import { connect } from 'react-redux'

let Announcer = ({ messages = [] }) => (
  <div className="visually-hidden">
    {messages.map(message => (
      <span role="alert">{message}</span>
    ))}
  </div>
)

export default connect(
  state => ({
    announcerMessages: state.app.announcerMessages
  })
)(Announcer)
